module.exports = __webpack_public_path__ + "97354930aae7b88555dacd9a3596c0bc.png";